// extracted by mini-css-extract-plugin
export default {"container":"RedirectLogin_container__oc0yr","shine":"RedirectLogin_shine__s6YmV"};